import {
    ApiQuery,
    BasicFilter,
    Filter,
    FilterMetadata,
    FilterOperators,
    FilterTypes,
} from "~/modules/filters/types";

// // // //

const RANGE_FILTER_TYPES = new Set<string>([
    FilterTypes.Dollar,
    FilterTypes.Integer,
    FilterTypes.PositiveInteger,
    FilterTypes.Float,
    FilterTypes.PositiveFloat,
    FilterTypes.Percent,
    FilterTypes.Date,
]);

/**
 * normalizeFilterOperators
 * Rewrites the `equals` operators FilterFormField applies by default on the
 * query's top-level filters:
 * - range-style fields (numbers / dates) get the metadata's defaultOperator (gte, after, ...)
 * - array values (e.g. network_ids) get `includes` when the field allows it,
 *   since `equals [ids]` would only match assets whose ids exactly equal the
 *   selected list
 * Filters without metadata, non-`equals` filters, and nested groups (e.g. the
 * 30D APY range) are left untouched.
 */
export function normalizeFilterOperators(
    query: ApiQuery,
    filterMetadata: FilterMetadata[],
): ApiQuery {
    if (!query.filter || !("filters" in query.filter)) {
        return query;
    }

    const filters = (query.filter.filters as BasicFilter[]).map((filter) => {
        const metadata = filterMetadata.find((m) => m.field === filter.field);
        if (!metadata || filter.operator !== FilterOperators.Equals) {
            return filter;
        }
        if (RANGE_FILTER_TYPES.has(metadata.type)) {
            return { ...filter, operator: metadata.defaultOperator };
        }
        if (
            Array.isArray(filter.value) &&
            metadata.allowedOperators.includes(FilterOperators.Includes)
        ) {
            return { ...filter, operator: FilterOperators.Includes };
        }
        return filter;
    });

    return { ...query, filter: { ...query.filter, filters } as Filter };
}
